<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ titulo }}</p>
    </header>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column is-9">
          <b-field label="Zona">
            <b-select
              :value="zona"
              type="is-info"
              :expanded="true"
              placeholder="Zona"
              @input="setZonaHandle"
            >
              <option
                v-for="option in zonas"
                :key="option.id"
                :value="option.id"
              >
                {{ option.nombre }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="Nº Ítems">
            <b-select
              :value="tamanoPagina"
              type="is-info"
              placeholder="N° Ítems"
              expanded
              @input="setPageSizeHandle"
            >
              <option v-for="option in tamanos" :key="option" :value="option">
                {{ option }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Tipo Pedido">
            <div>
              <b-checkbox v-model="tiposPedido" :native-value="1">
                Normal
              </b-checkbox>
              <b-checkbox v-model="tiposPedido" :native-value="2">
                R&aacute;pido
              </b-checkbox>
              <b-checkbox v-model="tiposPedido" :native-value="3">
                M&uacute;ltiple
              </b-checkbox>
              <b-checkbox v-model="tiposPedido" :native-value="4">
                Calzado
              </b-checkbox>
              <b-checkbox v-model="tiposPedido" :native-value="5">
                Pendiente
              </b-checkbox>
            </div>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Tipo Entrega">
            <div>
              <b-checkbox v-model="todosTiposEntrega"> Todos </b-checkbox>
              <b-checkbox
                v-for="item in listaTiposEntrega"
                :key="`tipo-entrega-${item.id}`"
                v-model="tiposEntrega"
                :native-value="`${item.id}`"
              >
                {{ item.nombre }}
              </b-checkbox>
            </div>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Por fecha">
            <b-switch :value="pedidosHoy" @input="setPedidosHoyHandle"
              >S&oacute;lo hoy</b-switch
            >
          </b-field>
        </div>
      </div>
    </div>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="closeFilterModalHandle">
        Cerrar
      </button>
    </footer>
    <b-loading
      :is-full-page="false"
      :can-cancel="false"
      :active.sync="isLoading"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Filtros',
  props: {
    modoMonitor: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tiposPedido:
        this.modo === 'despacho'
          ? this.$store.state.monitorDespacho.filtros.tiposPedido
          : this.$store.state.monitor.filtros.tiposPedido,
      tiposEntrega: [],
      isLoading: false,
      todosTiposEntrega: false
    }
  },
  computed: {
    ...mapGetters('monitor', ['tamanos', 'zonas', 'listaTiposEntrega']),
    modulo() {
      return this.modoMonitor === 'despacho' ? 'monitorDespacho' : 'monitor'
    },
    tamanoPagina() {
      return this.modoMonitor === 'despacho'
        ? this.$store.getters['monitorDespacho/tamanoPagina']
        : this.$store.getters['monitor/tamanoPagina']
    },
    tipoPedido() {
      return this.modoMonitor === 'despacho'
        ? this.$store.getters['monitorDespacho/tipoPedido']
        : this.$store.getters['monitor/tipoPedido']
    },
    titulo() {
      return `Filtros monitor ${
        this.modoMonitor.substring(0, 1).toUpperCase() +
        this.modoMonitor.substring(1)
      }`
    },
    zona() {
      return this.modoMonitor === 'despacho'
        ? this.$store.getters['monitorDespacho/zona']
        : this.$store.getters['monitor/zona']
    },
    pedidosHoy() {
      return this.modoMonitor === 'despacho'
        ? this.$store.getters['monitorDespacho/pedidosHoy']
        : this.$store.getters['monitor/pedidosHoy']
    }
  },
  watch: {
    tiposPedido(newValue) {
      this.setTiposPedidoHandle(newValue)
    },
    todosTiposEntrega(newValue) {
      if (!newValue) {
        const availables = this.listaTiposEntrega.map((i) => i.id)
        const newValues = [...this.tiposEntrega].sort()
        if (JSON.stringify(availables) === JSON.stringify(newValues)) {
          this.tiposEntrega = []
        }
      } else {
        const availables = this.listaTiposEntrega.map((i) => i.id)
        this.tiposEntrega = availables
      }
    },
    tiposEntrega(newValue) {
      const availables = this.listaTiposEntrega.map((i) => i.id)
      const newValues = [...newValue].sort()
      if (JSON.stringify(availables) === JSON.stringify(newValues)) {
        this.setTiposEntregaHandle(newValues)
        this.todosTiposEntrega = true
      } else {
        this.setTiposEntregaHandle(newValues)
        this.todosTiposEntrega = false
      }
    }
  },
  mounted() {
    this.getZonas()
    this.getTiposEntrega().then((_) => {
      const todos = this.listaTiposEntrega.map((i) => i.id)
      this.tiposEntrega =
        this.modo === 'despacho'
          ? this.$store.state.monitorDespacho.filtros.tiposEntrega || todos
          : this.$store.state.monitor.filtros.tiposEntrega || todos
    })
  },
  methods: {
    closeFilterModalHandle() {
      this.$emit('close')
    },
    setPageSizeHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setPageSize`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setTiposPedidoHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setTiposPedido`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setTiposEntregaHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setTiposEntrega`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setPedidosHoyHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setPedidosHoy`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setZonaHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setZona`, newValue)
        .catch((error) => this.procesarError(error))
    },
    async getZonas() {
      return this.$store
        .dispatch('monitor/getZonas')
        .catch((error) => this.procesarError(error))
    },
    async getTiposEntrega() {
      return this.$store
        .dispatch('monitor/getTiposEntrega')
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 5px;
  &:hover {
    background-color: hsla(204, 86%, 53%, 0.8);
  }
  .card-content {
    padding: 0.5rem 1rem;
    .columns {
      margin-bottom: 0px;
      .column {
        padding: 0.5rem;
      }
    }
  }
}
</style>
